import React, { useState, useEffect, useMemo } from 'react'
import lodash from 'lodash'
import styled from 'styled-components'

import { FormRow, Col } from '../../../../../../../1stlog-ui/src/components/Bootstrap'
import { useField, FeedbackBadge } from '../../../../../../../1stlog-ui/src/components/Field'

const validate = (v) => (v ? true : undefined)

const TransportCategoryCombination = (props) => {
  const { hazmats } = props

  const {
    input: {
      value: isTransportCategoryCombinationInvalid,
      onChange: setIsTransportCategoryCombinationInvalid
    },
    meta
  } = useField('validation.isTransportCategoryCombinationInvalid', {
    raw: true,
    validate,
    subscribeAll: true
  })

  useEffect(() => {
    const isInvalid =
      lodash.some(hazmats, (hazmat) => hazmat.transportCategory === '1') &&
      !lodash.every(hazmats, (hazmat) => hazmat.transportCategory === '1')
    setIsTransportCategoryCombinationInvalid(isInvalid)
  }, [hazmats])

  return (
    isTransportCategoryCombinationInvalid && (
      <FormRow>
        <Col>
          <FeedbackBadge meta={meta}>
            {i18n.t(
              'error_invalid_transport_category_combination',
              'Gefahrgüter der Beförderungskategorie 1 dürfen nicht zusammen mit Gefahrgütern anderer Beförderungskategorien transportiert werden'
            )}
          </FeedbackBadge>
        </Col>
      </FormRow>
    )
  )
}

export default TransportCategoryCombination
